export enum NotificationEventId {
  MarketingUpdates = 14,
  ProductUpdates = 15,
  SmsMarketingUpdates = 16,
  SmsProductUpdates = 17,
}
